import { render, staticRenderFns } from "./medicalRepSamples.vue?vue&type=template&id=304eb24e"
import script from "./medicalRepSamples.vue?vue&type=script&lang=js"
export * from "./medicalRepSamples.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports